import { createContext } from 'react';

export const FullPageErrorContext = createContext<{
  chartErrored: (chartId: string) => void;
  resetChartError: (chartId: string) => void;
}>({
  chartErrored: () => {
    throw new Error('addError must be used within a ChartErrorProvider');
  },
  resetChartError: () => {
    throw new Error('removeError must be used within a ChartErrorProvider');
  },
});
